exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "p i.icon[data-v-36259975]{width:16px;height:19px;margin-right:5px;display:inline-block;vertical-align:middle;background:url(" + require("images/icons/p-icon.png") + ") no-repeat 0 0}p i.icon-phone[data-v-36259975]{background-position:0 0}p i.icon-list[data-v-36259975]{background-position:0 -36px}p i.icon-email[data-v-36259975]{background-position:0 -69px}p i.icon-clock[data-v-36259975]{background-position:0 -104px}p i.icon-white-phone[data-v-36259975]{background-position:0 -138px}p i.pointer[data-v-36259975]{cursor:pointer}p .icon-text[data-v-36259975]{word-break:break-all}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36259975","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pIcon.vue
// module id = 837
// module chunks = 23